module.exports = {
  siteTitle: 'Krishnanshu Gupta',
  siteDescription:
    'Krishnanshu Gupta is currently a high schooler based in Silicon Valley, interested in designing websites, applications, and everything in between, and in exploring and learning more about the field of AI!',
  siteKeywords:
    'Krishnanshu Gupta, Krishnanshu, Gupta, kreedallc, software developer, programmer, web developer, java, flutter, monta vista, monta vista high school, flutter',
  siteUrl: 'https://krishnanshu-gupta.github.io',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-45666519-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',
  name: 'Krishnanshu Gupta',
  location: 'Silicon Valley',
  email: 'krishnanshu@gmail.com',
  github: 'https://github.com/krishnanshu-gupta',
  twitterHandle: '',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/krishnanshu-gupta',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/krishnanshu',
    },
    /*
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/kreedallc',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/Kreeda_LLC',
    }, */
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
    {
      name: 'Archive',
      url: '/archive',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
